import { Box, Button, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function StageFooter({
  stage,
  totalStages,
  onBack,
  onNext,
  nextLabel,
  nextDisabled,
  draftedAt,
  hideNext,
}) {
  const isLast = stage >= totalStages - 1;
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 3,
        px: 2.5,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.25,
        mt: 1,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {stage > 0 && (
          <Button
            startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
            onClick={onBack}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 14,
              color: 'text.secondary',
              borderRadius: '12px',
              px: 2,
              py: 1,
              '&:hover': { bgcolor: 'action.hover', color: 'text.primary' },
            }}
          >
            Back
          </Button>
        )}
      </Stack>

      {!isLast && !hideNext && (
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon sx={{ fontSize: 20 }} />}
          onClick={onNext}
          disabled={nextDisabled}
          disableElevation
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            fontSize: 15,
            color: '#fff',
            px: 3,
            py: 1.1,
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
            boxShadow: '0 6px 16px rgba(79,70,229,0.35)',
            '&:hover': {
              background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)',
              boxShadow: '0 8px 20px rgba(79,70,229,0.45)',
            },
            '&.Mui-disabled': {
              background: '#c7d2fe',
              color: '#fff',
              boxShadow: 'none',
            },
          }}
        >
          {nextLabel || `Next: ${stage + 2}`}
        </Button>
      )}
    </Box>
  );
}
